// extracted by mini-css-extract-plugin
export default {"p":"_93f2d723d1 _1ab2c6e00d _7866c29430","clr":"_48c8ed4f28","dls":"ee13d7727f"};